import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CarouselControls, CarouselNavigation, CarouselPagination, CarouselSlide, Carousel as DSCarousel } from "@cinch-labs/design-system";
import { FindSimilarVehiclesCard, VehicleCard } from "../cards";
import styles from "./carousel.module.css";
export var Carousel = function(param) {
    var carouselName = param.carouselName, slidesPerView = param.slidesPerView, vehicles = param.vehicles;
    var navAriaLabels = {
        previous: "Go to previous slide",
        next: "Go to next slide"
    };
    var swiperSettings = {
        spaceBetween: 16,
        slidesPerView: slidesPerView,
        cssMode: true,
        effect: "cards"
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(DSCarousel, {
                name: carouselName,
                swiperSettings: swiperSettings,
                ariaLabel: "".concat(carouselName, "-carousel"),
                children: [
                    vehicles.map(function(vehicle) {
                        return /*#__PURE__*/ _jsx(CarouselSlide, {
                            children: /*#__PURE__*/ _jsx(VehicleCard, {
                                vehicle: vehicle,
                                carouselName: carouselName
                            })
                        }, vehicle.vehicleId);
                    }),
                    vehicles.length <= 2 ? /*#__PURE__*/ _jsx(CarouselSlide, {
                        children: /*#__PURE__*/ _jsx(FindSimilarVehiclesCard, {})
                    }, "cta-card") : null
                ]
            }),
            /*#__PURE__*/ _jsxs(CarouselControls, {
                customClassNames: styles["controlsWrapper"],
                children: [
                    /*#__PURE__*/ _jsx(CarouselPagination, {
                        name: carouselName,
                        customClassNames: styles["customPagination"]
                    }),
                    /*#__PURE__*/ _jsx(CarouselNavigation, {
                        name: carouselName,
                        ariaLabels: navAriaLabels,
                        customClassNames: {
                            prevButton: styles["prevButton"],
                            nextButton: styles["nextButton"]
                        }
                    })
                ]
            })
        ]
    });
};
